export default __webpack_public_path__ + "static/media/hand.566c134f.png";